<div class="col-md-12">
  <div class="loggedin-bg">
    <div class="offset-md-3 mt-5">
      <h3>The page is under construction</h3>
    </div>
  </div>
</div>
